import React from 'react';
import { formatValue } from './DataTableCard';

const PRIORITY_STYLES = {
  high:   { border: 'border-l-red-500', bg: 'bg-red-50/40' },
  medium: { border: 'border-l-amber-500', bg: 'bg-amber-50/40' },
  low:    { border: 'border-l-blue-500', bg: 'bg-blue-50/40' },
};

const RecommendationsCard = ({ card }) => {
  if (!card || !card.items || card.items.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 shadow-sm w-full mt-3">
      {card.title && (
        <div className="text-xs font-semibold text-gray-700 mb-3">{card.title}</div>
      )}
      <div className="space-y-2">
        {card.items.slice(0, 3).map((item, i) => {
          const ps = PRIORITY_STYLES[item.priority] || PRIORITY_STYLES.low;
          return (
            <div
              key={i}
              className={`${ps.bg} border-l-4 ${ps.border} rounded-r-lg p-3 flex items-start gap-3`}
            >
              {item.icon && <span className="text-lg flex-shrink-0">{item.icon}</span>}
              <div className="flex-1 min-w-0">
                <div className="text-[11px] font-semibold text-gray-800">{item.title}</div>
                <div className="text-[10px] text-gray-600 mt-0.5">{item.description}</div>
              </div>
              {item.metric && (
                <div className="flex-shrink-0 text-right">
                  <div className="text-[9px] text-gray-400">{item.metric.label}</div>
                  <div className="text-[12px] font-bold">
                    {formatValue(item.metric.value, item.metric.format, item.metric.label)}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {card.period && (
        <div className="mt-3 text-[10px] text-gray-400 text-right font-mono">
          {card.period.start} &rarr; {card.period.end}
        </div>
      )}
    </div>
  );
};

export default RecommendationsCard;
